import { useQuery } from '@tanstack/react-query';
import { IBirth } from '@clickersphere/core/entities/IBirth';
import BirthService from '@clickersphere/core/services/BirthService';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const BIRTHS_QUERY_KEY = 'births';

export type BirthQueryData = WithQueryStatus<IBirth>;

export function useBirths(leadId?: string, enabled = true) {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: births,
    isSuccess: isBirthsSuccess,
    isFetching: isBirthsFetching,
    isLoading: isBirthsLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: enabled && !!selectedTenantId,
    queryKey: buildQueryKey([BIRTHS_QUERY_KEY, leadId]),
    queryFn: async () => {
      const result = await BirthService.getAll(leadId);
      return result as BirthQueryData[];
    },
  });

  return {
    births: births ?? [],
    isBirthsSuccess,
    isBirthsFetching,
    isBirthsLoading,
  };
}
